// extracted by mini-css-extract-plugin
export default {"header":"CellHeader_header__CWnca","sticky":"CellHeader_sticky__VdswJ"};